import { ServiceRequestStatus } from '@commenda/prisma';
import type { ServiceRequestDetails } from '@commenda/types/src/service-request/types';

export type TServiceRequestStatusBadgeVariant =
  | 'gray'
  | 'warning'
  | 'success'
  | 'blue';

export interface IServiceRequestStatusBadge {
  variant: TServiceRequestStatusBadgeVariant;
  text: string;
}

export class ServiceRequestStatusBadgeHelper {
  static readonly STATUS_BADGES: Partial<
    Record<ServiceRequestStatus, IServiceRequestStatusBadge>
  > = {
    [ServiceRequestStatus.NOT_STARTED]: {
      variant: 'gray',
      text: 'Not Started',
    },
    [ServiceRequestStatus.IN_PROGRESS]: {
      variant: 'warning',
      text: 'In Progress',
    },
    [ServiceRequestStatus.COMPLETED]: { variant: 'success', text: 'Completed' },
  };

  static getBadgeProps(
    serviceRequest:
      | Pick<ServiceRequestDetails, 'status' | 'isOnHold'>
      | null
      | undefined
  ): IServiceRequestStatusBadge {
    if (!serviceRequest) {
      return { variant: 'gray', text: '' };
    }

    if (serviceRequest.isOnHold) {
      return { variant: 'blue', text: 'On Hold' };
    }

    const statusInfo =
      ServiceRequestStatusBadgeHelper.STATUS_BADGES[serviceRequest.status];

    return {
      variant: statusInfo?.variant || 'gray',
      text: statusInfo?.text || 'Unknown',
    };
  }
}
